import "./App.css";
import Header from "./companents/Header";
import Question from "./companents/Question";



function App() {
  return (
    <div>
      <Header />
      <Question />
    </div>
  );
}

export default App;
